/*
 *
 * Copyright 2019, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */

import React from 'react';
import ReactDOM from "react-dom";
import $ from 'jquery'; // eslint-disable-line

import {Button, Dialog, Classes, HTMLSelect, NonIdealState} from "@blueprintjs/core";
import {Menu, MenuItem} from "@blueprintjs/core";
import {Intent} from "@blueprintjs/core/lib/esm/index";
import {Cell, Column, Table, ColumnHeaderCell, Utils, SelectionModes} from "@blueprintjs/table";
import '@blueprintjs/table/lib/css/table.css';
//import {WrcGlobal} from "./WrcGlobal.js";
import {WrcServer} from "./WrcServer.js";


export class WrcSpreadSheet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            is_loaded: false,
            form: {tabs: []},
            data: [],
            show_confirm: false,
            form_tab: 0,
            filterIndices: [],
            searchIndices: [],
            filters: [],
            current_query:"",
            choosen_filter: "Select...",
            retainedIndices: [],
            retainedData: [],
            sortedIndexMap: []
        };
    }

    componentDidMount() {
        let payload = {form_id: this.props.form_id};

        WrcServer.post('get-spread',
                payload,
                (content) => this.getData(content)
        );
    }

    render() {
        if (this.state.is_loaded){
            let columns_to_render = this.state.reordered_cols.map((col, index) => {
                return this.getColumn(col, index);
            }, this);
            let numRows=this.state.retainedIndices.length;
            let spreadsheet_to_render;
            if (this.state.data.length > 0){
                spreadsheet_to_render =(
                    <Table
                        numRows={numRows}
                        defaultRowHeight={40}
                        numFrozenColumns={1}
                        bodyContextMenuRenderer={this.cellMenuRenderer}
                        selectionModes={SelectionModes.ROWS_ONLY}>
                        {columns_to_render}
                    </Table>
                );
            } else {
                spreadsheet_to_render =(
                    <Table
                        numRows={numRows}
                        defaultRowHeight={40}
                        numFrozenColumns={1}
                        bodyContextMenuRenderer={this.cellMenuRenderer}
                        selectionModes={SelectionModes.ROWS_ONLY}>
                    </Table>
                );
            }

            let filter_options = ((this.state.filters !== undefined || this.state.filters.length > 0) ?
                this.state.filters.map((filter) => {
                    return (<option value={filter.label} label={filter.label}> {filter.label} </option>);
                }, this) : []);

            let disable_filters= (this.state.filters === undefined || this.state.filters === []) ? true : false;

            return (
                <Dialog
                        isOpen={true}
                        onClose={this.closeSpreadsheet}
                        canOutsideClickClose={false}
                        title={this.state.title}
                        id="web_form"
                        style={{minWidth: 1100, minHeight: 600, maxWidth: 1400, maxHeight: 800, overflow: 'scroll'}} >
                    <div className={Classes.DIALOG_BODY}>
                        <div>
                            <div class="bp3-input-group" style={{'marginBottom': '4px', 'width': '50%'}}>
                              <span class="bp3-icon bp3-icon-search"></span>
                              <input className={'bp3-input'}
                                  type='text'
                                  onChange={this.search}
                                  placeholder={`Search by ${this.state.first_col}`}
                              />
                            </div>
                            <div>
                                <span> Filter By: </span>
                                <HTMLSelect
                                    style={{'marginBottom': '4px'}}
                                    value={this.state.choosen_filter}
                                    onChange={this.filter}
                                    disabled={disable_filters}>
                                    {filter_options}
                                </HTMLSelect>
                            </div>
                        </div>
                        <div style={{'marginBottom': '4px'}}>
                            {spreadsheet_to_render}
                        </div>
                    </div>
                    <div className={Classes.DIALOG_FOOTER}>
                        <div className={'bp3-dialog-footer-actions'} style={{float: 'right', padding: 10}}>
                            <Button onClick={this.closeSpreadsheet} text="Cancel" type={'button'}/>
                            <Button
                                intent={Intent.SUCCESS}
                                text="OK"
                                type={'submit'}
                                onClick={this.save}
                                disabled={false}/>
                        </div>
                    </div>
                </Dialog>
            );
        } else {
            return (
                <Dialog
                        isOpen={true}
                        canOutsideClickClose={false}
                        title={this.state.title}
                        id="web_form"
                        style={{minWidth: 1100, minHeight: 600, maxWidth: 1400, maxHeight: 800, overflow: 'scroll'}} >
                    <div className={Classes.DIALOG_BODY}>
                        <NonIdealState icon='th' title='No Master List Entries Exist' description='Please create a master list entry for each patient in the system.'/>
                    </div>
                    <div className={Classes.DIALOG_FOOTER}>
                        <div className={'bp3-dialog-footer-actions'} style={{float: 'right', padding: 10}}>
                            <Button onClick={this.closeSpreadsheet} text="Close" type={'button'}/>
                        </div>
                    </div>
                </Dialog>
            );
        }
    }

    search = (e) => {
        e.persist();
        let current_query=e.target.value;
        let searchIndices=[];
        this.state.data.forEach((entry, index) => {
            if(`${entry[this.state.first_col].toString().toLowerCase()}`.indexOf(current_query.toString().toLowerCase()) >= 0){
                searchIndices.push(index);
            }
        }, this);

        let fin_inds = searchIndices.filter((ind) => {
            return this.state.filterIndices.includes(ind);
        }, this);

        let fin_vals= this.state.data.filter((dat, index) => {
            return fin_inds.includes(index);
        }, this);

        this.setState({
            current_query: current_query,
            retainedIndices: fin_inds,
            searchIndices: searchIndices,
            retainedData: fin_vals
        });
    }

    filter = (e) => {
        e.persist();
        let filterIndices=[];
        let selected_filter= this.state.filters.find((filter) => (filter.label === e.target.value));
        if(selected_filter.label !== "Select..."){
            this.state.data.forEach((entry, index) => {
                if (selected_filter.values.includes(entry[selected_filter.field_name])){
                    filterIndices.push(index);
                }
            }, this);
        } else {
            for (let i=0; i<this.state.data.length; i++){
                filterIndices.push(i);
            }
        }

        let fin_inds = filterIndices.filter((ind) => {
            return this.state.searchIndices.includes(ind);
        }, this);

        let choosen_filter= selected_filter.label;

        let fin_vals= this.state.data.filter((dat, index) => {
            return fin_inds.includes(index);
        }, this);

        this.setState({
            retainedIndices: fin_inds,
            filterIndices: filterIndices,
            choosen_filter: choosen_filter,
            retainedData: fin_vals
        });
    }

    getColumn = (col, index) => {
        const cellRenderer = (rowIndex, columnIndex) => {
            let isEditable= false;
            this.state.form.tabs[this.state.form_tab].elements.forEach((elem) => {
                if (elem.column_name === col){
                    isEditable= elem.editable;
                }
            }, this);

            return (<Cell style={{fontSize: '0.9rem'}} interactive={true}>{this.getCellData(rowIndex, columnIndex, isEditable)}</Cell>);
        };
        const colLabel = (this.state.col_labels[col]) ? this.state.col_labels[col] : col;
        const columnHeaderCellRenderer = () => {
            if(index === 0 && col === this.state.first_col){
                return (<ColumnHeaderCell name={colLabel} menuRenderer={this.headerMenuRenderer} />);
            } else {
                return (<ColumnHeaderCell name={colLabel} />);
            }
        };
        return (
            <Column
                cellRenderer={cellRenderer}
                columnHeaderCellRenderer={columnHeaderCellRenderer}
                key={index}
                name={col}
            />
        );
    }

    getCellData = (rowIndex, columnIndex, isEditable) => {
        let newSorted= this.state.sortedIndexMap.filter((ind) => this.state.retainedIndices.includes(ind));
        const sortedRowIndex = newSorted[rowIndex];
        if (sortedRowIndex != null) {
            rowIndex = sortedRowIndex;
        }

        let id= this.state.data[rowIndex][this.state.first_col];
        if(isEditable){
            if(this.state.col_types[this.state.reordered_cols[columnIndex]] === 'select' || this.state.col_types[this.state.reordered_cols[columnIndex]] === 'radio' || this.state.col_types[this.state.reordered_cols[columnIndex]] === 'select-suggest'){
                return (this.createSelectCell(id, this.state.reordered_cols[columnIndex]));
            } else if (this.state.col_types[this.state.reordered_cols[columnIndex]] === 'date'){
                return (this.createDateCell(id, this.state.reordered_cols[columnIndex]));
            } else {
                return (this.createDefaultCell(id, this.state.reordered_cols[columnIndex]));
            }
        } else {
            return (this.createUneditableCell(id, this.state.reordered_cols[columnIndex]));
        }
    }

    headerMenuRenderer = () => {
        const sortAsc = () => this.sortColumn((a,b) => this.compareFunc(a,b));
        const sortDesc = () => this.sortColumn((a,b) => this.compareFunc(b,a));
        return (
            <Menu>
                <MenuItem icon="sort-asc" onClick={sortAsc} text="Sort Asc" />
                <MenuItem icon="sort-desc" onClick={sortDesc} text="Sort Desc" />
            </Menu>
        );
    }

    cellMenuRenderer = (context) => {
        let target=context.getTarget();
        if (target.cols[0]===0 && target.cols[1]===0 && target.rows[0]===target.rows[1]){
            let rec_id=this.getCellData(target.rows[0], target.cols[0], false);
            let recordToProcess=this.state.data.filter((elem) => (elem[this.state.first_col]===rec_id));
            return (
                <Menu>
                    <MenuItem icon="share" onClick={this.openLinkedComponent(recordToProcess[0])} text="Open record" />
                </Menu>
            );
        } else {
            return;
        }
    }

    sortColumn = (comparator) => {
        const { data } = this.state;
        const sortedIndexMap = Utils.times(data.length, (i) => i);
        sortedIndexMap.sort((a, b) => {
            return comparator(data[a][this.state.first_col], data[b][this.state.first_col]);
        });
        this.setState({ sortedIndexMap });
    }

    compareFunc = (input1, input2) => {
        if (typeof input1 === 'string' && typeof input2 === 'string'){
            return input1.localeCompare(input2)
        } else if (Number.isFinite(input1) && Number.isFinite(input2)){
            return input1 - input2;
        } else {
            return 0;
        }
    }

    handleInputChange = (id, col_name) => (e) => {
        e.persist();
        var latest = Array.from(this.state.data);
        let record_index= this.state.data.findIndex((rec)=> (rec[this.state.first_col]===id));
        let record= this.state.data.find((rec)=> (rec[this.state.first_col]===id));
        record[col_name] = e.target.value;
        let temp= latest.filter((elem) => {
            return (elem[this.state.first_col] !== id);
        }, this);
        temp.splice(record_index, 0, record);
        this.setState({data: temp});
        this.updateTable();
    }

    updateTable (){
        let searchIndices=[];
        let filterIndices=[];
        let fin_inds=[];
        for (let i=0; i<this.state.data.length; i++){
            fin_inds.push(i);
        }

        this.state.data.forEach((entry, index) => {
            if(`${entry[this.state.first_col].toString().toLowerCase()}`.indexOf(this.state.current_query.toString().toLowerCase()) >= 0){
                searchIndices.push(index);
            }
        }, this);

        let selected_filter= this.state.filters.find((filter) => (filter.label === this.state.choosen_filter));
        if(selected_filter.label !== "Select..."){
            this.state.data.forEach((entry, index) => {
                if (selected_filter.values.includes(entry[selected_filter.field_name])){
                    filterIndices.push(index);
                }
            }, this);
        } else {
            for (let i=0; i<this.state.data.length; i++){
                filterIndices.push(i);
            }
        }

        fin_inds=fin_inds.filter((ind) => {
            return (filterIndices.includes(ind) && searchIndices.includes(ind));
        }, this);

        let fin_vals= this.state.data.filter((dat, index) => {
            return fin_inds.includes(index);
        }, this);

        this.setState({
            searchIndices: searchIndices,
            filterIndices: filterIndices,
            retainedIndices: fin_inds,
            retainedData: fin_vals
        });
    }

    createUneditableCell(id, col_name){
        let record= this.state.retainedData.find((rec) => (rec[this.state.first_col]===id));
        return (record[col_name]);
    }

    createDefaultCell(id, col_name){
        let record= this.state.retainedData.find((rec)=> (rec[this.state.first_col]===id));
        return (
            <input className={'bp3-input'}
                style={{'width':'100%', 'marginTop': '4px'}}
                name={col_name}
                type='text'
                value={record[col_name]}
                onChange={this.handleInputChange(id, col_name)}/>
        );
    }

    createDateCell(id, col_name){
        let record= this.state.retainedData.find((rec)=> (rec[this.state.first_col]===id));
        return (
            <input className={'bp3-input'}
                style={{'width':'100%', 'marginTop': '4px'}}
                name={col_name}
                type='date'
                value={record[col_name]}
                onChange={this.handleInputChange(id, col_name)}/>
        );
    }

    createSelectCell(id, col_name){
        let record= this.state.retainedData.find((rec)=> (rec[this.state.first_col]===id));
        let selectOptionList= undefined;
        this.state.form.tabs[this.state.form_tab].elements.forEach((element, element_index) => {
            if (element.column_name===col_name){
                selectOptionList = element.responses.map(function(response) {
                    return (
                        <option value={response.value} label={response.label ? response.label : response.value}>{response.value}</option>
                    );
                });
            }
        }, this);

        return(
            <HTMLSelect
                    style={{'width':'100%', 'marginTop': '4px'}}
                    name={col_name}
                    value={record[col_name]}
                    onChange={this.handleInputChange(id, col_name)}>
                <option value="Select...">Select...</option>
                {selectOptionList}
            </HTMLSelect>
        );
    }

    afterSave = (content) => {
        this.props.refresh();
        this.closeSpreadsheet();
    }

    closeSpreadsheet = () => {
        ReactDOM.unmountComponentAtNode(document.querySelector('#spreadsheet'));
    };

    openLinkedComponent = (record) => (e) => {
        e.persist();
        let val=record[this.props.sheet_linking_property];
        this.props.configure_component(this.props.linked_component_index, {[this.props.component_linking_property] : val});
        this.save();

    }

    getData = (content) => {
        let col_types={};
        let col_labels={};
        content.form.tabs.forEach((tab, tab_index) => {
            tab.elements.forEach((element, element_index) => {
                let name = element.column_name ? element.column_name : element.table_name;
                col_types[name]=element.element_type;
                col_labels[name]=element.label;
            }, this);
        }, this);
        let is_loaded=false;
        if (content.data && content.data.length > 0){
            is_loaded=true;
        }

        let col_names= Object.keys(content.data[0]);
        let reordered_cols=col_names.filter((name) => (name !== this.props.first_col));
        reordered_cols.unshift(this.props.first_col);

        let filters=[...this.props.filters];
        filters.unshift({"label":"Select..."});
        let searchIndices=[];
        let filterIndices=[];
        let retainedIndices=[];
        let sortedIndexMap=[];
        for (let i=0; i<content.data.length; i++){
            searchIndices.push(i);
            filterIndices.push(i);
            retainedIndices.push(i);
            sortedIndexMap.push(i);
        }

        this.setState({
            form: content.form,
            data: content.data,
            references: content.references,
            formOpen: true,
            is_loaded: is_loaded,
            col_types: col_types,
            form_tab: this.props.form_tab,
            first_col: this.props.first_col,
            title: this.props.title,
            reordered_cols: reordered_cols,
            searchIndices: searchIndices,
            filterIndices: filterIndices,
            retainedIndices: retainedIndices,
            retainedData: content.data,
            col_labels: col_labels,
            filters: filters,
            sortedIndexMap: sortedIndexMap
        });
    }

    save = () => {
        var post = {
            table_schema: this.state.form.table_schema,
            table_name: this.state.form.table_name,
            data: this.state.data
        }

        WrcServer.post('save-spread',
                post,
                (content) => this.afterSave(content)
        );
    }
}
